"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFrameTransformationParams = void 0;
const tiles_1 = require("../consts/tiles");
function getFrameFileName({ frameColor, prefix }) {
    let filename = `${prefix}-${frameColor}`;
    filename += '.png';
    return filename;
}
/**
 * Return transformation params for wide tiles - which will be shown in the preview
 * email. Some tile sizes has the same asset. We have the following assets:
 * - Square
 * - Portrait
 * - Landscape
 * - 22X44
 * - 44X22
 *
 * @param frameColor
 * @param tileSize
 * @return {{innerSize: {width: number, height: number}, offset: {x: number, y: number}, name: string}}
 */
function getWideFrameTransformationParams({ frameColor, tileSize }) {
    if ([tiles_1.TILE_SIZES.SQUARE_8X8, tiles_1.TILE_SIZES.SQUARE_12X12, tiles_1.TILE_SIZES.SQUARE_20X20].includes(tileSize)) {
        const frameFileName = getFrameFileName({ frameColor, prefix: 'WIDE-square' });
        return {
            name: frameFileName,
            innerSize: {
                width: 712,
                height: 712
            },
            offset: {
                x: 10,
                y: 30
            }
        };
    }
    else if ([tiles_1.TILE_SIZES.RECTANGLE_8X11, tiles_1.TILE_SIZES.RECTANGLE_12X16, tiles_1.TILE_SIZES.RECTANGLE_20X27, tiles_1.TILE_SIZES.RECTANGLE_27X36].includes(tileSize)) {
        const frameFileName = getFrameFileName({ frameColor, prefix: 'WIDE-vertical' });
        return {
            name: frameFileName,
            innerSize: {
                width: 712,
                height: 994
            },
            offset: {
                x: 11,
                y: 29
            }
        };
    }
    else if ([tiles_1.TILE_SIZES.RECTANGLE_11X8, tiles_1.TILE_SIZES.RECTANGLE_16X12, tiles_1.TILE_SIZES.RECTANGLE_27X20, tiles_1.TILE_SIZES.RECTANGLE_36X27].includes(tileSize)) {
        const frameFileName = getFrameFileName({ frameColor, prefix: 'WIDE-horizontal' });
        return {
            name: frameFileName,
            innerSize: {
                width: 992,
                height: 710
            },
            offset: {
                x: 10,
                y: 31
            }
        };
    }
    else if (tileSize === tiles_1.TILE_SIZES.RECTANGLE_22X44) {
        return {
            innerSize: {
                width: 525,
                height: 1048
            },
            offset: {
                x: 7,
                y: 22
            },
            name: getFrameFileName({ frameColor, prefix: `WIDE-${tileSize}` })
        };
    }
    else if (tileSize === tiles_1.TILE_SIZES.RECTANGLE_44X22) {
        return {
            innerSize: {
                width: 1048,
                height: 525
            },
            offset: {
                x: 21,
                y: 13
            },
            name: getFrameFileName({ frameColor, prefix: `WIDE-${tileSize}` })
        };
    }
    throw new Error(`wrong tile size - ${tileSize}`);
}
// Return properties required for a cloudinary transformation that sets the tile image inside a frame
function getFrameTransformationParams({ frameColor, tileSize, materialType }) {
    if (materialType === tiles_1.MATERIAL_TYPES.WIDE_FRAME) {
        return getWideFrameTransformationParams({ frameColor, tileSize });
    }
    if ((frameColor && ['none', 'frameless'].includes(frameColor.toLowerCase())) || materialType !== tiles_1.MATERIAL_TYPES.CLASSIC) {
        switch (tileSize) {
            case tiles_1.TILE_SIZES.SQUARE_4X4:
                return {
                    innerSize: {
                        width: 300,
                        height: 300
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_4X6:
                return {
                    innerSize: {
                        width: 225,
                        height: 300
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_6X4:
                return {
                    innerSize: {
                        width: 225,
                        height: 300
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_6X8:
                return {
                    innerSize: {
                        width: 225,
                        height: 300
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_8X6:
                return {
                    innerSize: {
                        width: 300,
                        height: 225
                    }
                };
            case tiles_1.TILE_SIZES.SQUARE_8X8:
                return {
                    innerSize: {
                        width: 300,
                        height: 300
                    }
                };
            case tiles_1.TILE_SIZES.SQUARE_12X12:
                return {
                    innerSize: {
                        width: 450,
                        height: 450
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_8X11:
                return {
                    innerSize: {
                        width: 300,
                        height: 412
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_11X8:
                return {
                    innerSize: {
                        width: 412,
                        height: 300
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_12X16:
                return {
                    innerSize: {
                        width: 450,
                        height: 600
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_16X12:
                return {
                    innerSize: {
                        width: 600,
                        height: 450
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_16X20:
                return {
                    innerSize: {
                        width: 360,
                        height: 450
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_20X16:
                return {
                    innerSize: {
                        width: 450,
                        height: 360
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_25X8:
                return {
                    innerSize: {
                        width: 600,
                        height: 200
                    }
                };
            case tiles_1.TILE_SIZES.SQUARE_20X20:
                return {
                    innerSize: {
                        width: 450,
                        height: 450
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_27X20:
                return {
                    innerSize: {
                        width: 608,
                        height: 450
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_20X27:
                return {
                    innerSize: {
                        width: 450,
                        height: 608
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_36X27:
                return {
                    innerSize: {
                        width: 608,
                        height: 450
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_27X36:
                return {
                    innerSize: {
                        width: 450,
                        height: 608
                    }
                };
            case tiles_1.TILE_SIZES.RECTANGLE_22X44:
                return {
                    width: 350,
                    height: 700
                };
            case tiles_1.TILE_SIZES.RECTANGLE_44X22: {
                return {
                    width: 700,
                    height: 350
                };
            }
            case tiles_1.TILE_SIZES.SQUARE_30X30: {
                return {
                    width: 525,
                    height: 525
                };
            }
            case tiles_1.TILE_SIZES.SQUARE_40X40: {
                return {
                    width: 700,
                    height: 700
                };
            }
            case tiles_1.TILE_SIZES.HONEYCOMB_11X10: {
                return {
                    innerSize: {
                        width: 751,
                        height: 650
                    },
                    offset: {
                        x: 4,
                        y: 6
                    },
                    name: getFrameFileName({
                        frameColor,
                        prefix: tileSize
                    })
                };
            }
            case tiles_1.TILE_SIZES.HONEYCOMB_10X11: {
                return {
                    innerSize: {
                        width: 652,
                        height: 752
                    },
                    offset: {
                        x: 6,
                        y: 5
                    },
                    name: getFrameFileName({
                        frameColor,
                        prefix: tileSize
                    })
                };
            }
        }
        throw new Error(`We're not support frameless for - tileSize - ${tileSize}`);
    }
    if (tileSize === tiles_1.TILE_SIZES.SQUARE_8X8 || tileSize === tiles_1.TILE_SIZES.SQUARE_4X4) {
        const frameFileName = getFrameFileName({ frameColor, prefix: tiles_1.TILE_SIZES.SQUARE_8X8 });
        return {
            name: frameFileName,
            innerSize: {
                width: 780,
                height: 780
            },
            offset: {
                x: 10,
                y: 32
            }
        };
    }
    else if (tileSize === tiles_1.TILE_SIZES.SQUARE_20X20 || tileSize === tiles_1.TILE_SIZES.SQUARE_12X12) {
        const frameFileName = getFrameFileName({ frameColor, prefix: tileSize });
        return {
            name: frameFileName,
            innerSize: {
                width: 1032,
                height: 1032
            },
            offset: {
                x: 10,
                y: 30
            }
        };
    }
    else if (tileSize === tiles_1.TILE_SIZES.CIRCLE_10) {
        const frameFileName = getFrameFileName({ frameColor, prefix: tileSize });
        return {
            name: frameFileName,
            innerSize: {
                width: 875,
                height: 875
            },
            offset: {
                x: 10,
                y: 30
            },
            radius: 'max'
        };
    }
    else if ([tiles_1.TILE_SIZES.RECTANGLE_8X11, tiles_1.TILE_SIZES.RECTANGLE_12X16, tiles_1.TILE_SIZES.RECTANGLE_20X27, tiles_1.TILE_SIZES.RECTANGLE_27X36].includes(tileSize)) {
        const frameFileName = getFrameFileName({ frameColor, prefix: 'RECTANGLE-vertical' });
        return {
            name: frameFileName,
            innerSize: {
                width: 774,
                height: 1055
            },
            offset: {
                x: 10,
                y: 30
            }
        };
    }
    else if ([tiles_1.TILE_SIZES.RECTANGLE_11X8, tiles_1.TILE_SIZES.RECTANGLE_16X12, tiles_1.TILE_SIZES.RECTANGLE_27X20, tiles_1.TILE_SIZES.RECTANGLE_36X27].includes(tileSize)) {
        const frameFileName = getFrameFileName({ frameColor, prefix: 'RECTANGLE-horizontal' });
        return {
            name: frameFileName,
            innerSize: {
                width: 1064,
                height: 780
            },
            offset: {
                x: 10,
                y: 32
            }
        };
    }
    else if (tileSize === tiles_1.TILE_SIZES.HONEYCOMB_11X10) {
        return {
            innerSize: {
                width: 695,
                height: 602
            },
            offset: {
                x: 6,
                y: 6
            },
            name: getFrameFileName({ frameColor, prefix: tileSize })
        };
    }
    else if (tileSize === tiles_1.TILE_SIZES.HONEYCOMB_10X11) {
        return {
            innerSize: {
                width: 603,
                height: 696
            },
            offset: {
                x: 7,
                y: 5
            },
            name: getFrameFileName({ frameColor, prefix: tileSize })
        };
    }
    else if (tileSize === tiles_1.TILE_SIZES.RECTANGLE_22X44) {
        return {
            innerSize: {
                width: 525,
                height: 1048
            },
            offset: {
                x: 7,
                y: 22
            },
            name: getFrameFileName({ frameColor, prefix: tileSize })
        };
    }
    else if (tileSize === tiles_1.TILE_SIZES.RECTANGLE_44X22) {
        return {
            innerSize: {
                width: 1048,
                height: 525
            },
            offset: {
                x: 21,
                y: 13
            },
            name: getFrameFileName({ frameColor, prefix: tileSize })
        };
    }
    throw new Error(`wrong tile size - ${tileSize}`);
}
exports.getFrameTransformationParams = getFrameTransformationParams;
//# sourceMappingURL=cloudinaryTransformations.js.map